<template>
  <main>
    <div class="bg-gray-200 py-2">
      <div class="breadcrumbs container mx-auto">
        <nuxt-link :to="localePath('index')" class="breadcrumb px-2">{{
          $t('home')
        }}</nuxt-link>
        <nuxt-link :to="localePath('about')" class="breadcrumb px-2">{{
          $t('about_us')
        }}</nuxt-link>
        <nuxt-link
          :to="localePath('about-certificates')"
          class="breadcrumb px-2"
          >{{ $t('certificates') }}</nuxt-link
        >
      </div>
    </div>
    <div
      class="submenu px-4 py-8 container mx-auto flex flex-col md:flex-row justify-center"
    >
      <nuxt-link
        :to="localePath('about-history')"
        class="items-center flex flex-col md:w-1/4"
      >
        <img class="self-center submenu-icon" src="/img/icons/history.png" />
        <p class="text-black text-center mt-0 mb-4">{{ $t('history') }}</p>
      </nuxt-link>
      <nuxt-link
        :to="localePath('about-numbers')"
        class="items-center flex flex-col md:w-1/4"
      >
        <img
          class="self-center submenu-icon"
          src="/img/icons/numbers_and_facts.png"
        />
        <p class="text-black text-center mt-0 mb-4">
          {{ $t('numbers_and_facts') }}
        </p>
      </nuxt-link>
      <nuxt-link
        :to="localePath('about-certificates')"
        class="items-center flex flex-col md:w-1/4"
      >
        <img
          class="self-center submenu-icon"
          src="/img/icons/certificates.png"
        />
        <p class="text-black text-center mt-0 mb-4">{{ $t('certificates') }}</p>
      </nuxt-link>
    </div>
    <div class="header text-center py-32">
      <h1 class="text-3xl text-white font-bold">{{ $t('certificates') }}</h1>
    </div>
    <section class="about px-4 container mx-auto text-justify">
      <div class="about-content bg-white px-8 py-8 md:px-20 md:py-20">
        <h3 class="text-2xl font-semibold mb-4">{{ $t('overview') }}</h3>
        <div>
          <p class="text-grey-600">{{ $t('certificates_short') }}</p>
        </div>
        <div v-for="el in sertificates" :key="el.alt">
          <StandardCard
            :standard="el.standard"
            :standard2="el.standard2"
            :name="el.name"
            :src="el.src"
            :alt="el.alt"
            :content-name="el.contentName"
            :file-path="el.filePath"
            :file-path2="el.filePath2"
            :sgs="el.sgs"
          />
        </div>

        <h3 class="text-2xl font-semibold mb-4">{{ $t('our_policies') }}</h3>
        <div v-for="policy in policies" :key="policy.name">
          <a
            :href="$t(policy.name + '_link')"
            target="_blank"
            class="text-xl underline font-medium"
            >{{ $t(policy.name + '_name') }}</a
          >
        </div>
      </div>

      <div class="text-center my-6 pb-4">
        <h4 class="font-bold text-2xl">{{ $t('anything_you_need_help') }}</h4>
        <div class="flex flex-wrap justify-center">
          <nuxt-link
            :to="localePath('solutions')"
            class="button w-56 bg-red-600 hover:bg-red-700 px-12 uppercase hover:text-white mt-6 sm:mr-3 text-white px-5 py-3"
            >{{ $t('OUR_SOLUTIONS') }}</nuxt-link
          >
          <nuxt-link
            :to="localePath('contact')"
            class="button w-56 bg-transparent text-black uppercase border-2 border-black px-5 py-3 mt-6 hover:bg-black hover:text-white"
            >{{ $t('contact') }}</nuxt-link
          >
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import StandardCard from '@/components/StandardCard.vue'
export default {
  components: {
    StandardCard
  },
  data() {
    return {
      sertificates: [
        {
          standard: 'ISO 9001',
          name: 'iso9001_name',
          src: '/img/sertificates/logo/iso9001.jpg',
          alt: 'ISO 14001',
          contentName: 'iso9001_text',
          filePath: '/doc/sertificates/ISO9001MilspedDoo.pdf',
          sgs: true
        },
        {
          standard: 'HACCP',
          name: 'haccp_name',
          alt: 'HACCP',
          contentName: 'haccp_text',
          src: '/img/sertificates/logo/haccp.jpg',
          filePath: '/doc/sertificates/HACCP-sertifikat-2022-2025.pdf',
          sgs: true
        },
        {
          standard: 'ISO 14001',
          name: 'iso14001_name',
          src: '/img/sertificates/logo/iso14001.jpg',
          alt: 'ISO 14001',
          contentName: 'iso14001_text',
          filePath: '/doc/sertificates/ISO 14001.pdf',
          sgs: true
        },
        {
          standard: 'ISO 45001',
          name: 'iso45001_name',
          alt: 'ISO 45001',
          contentName: 'iso45001_text',
          src: '/img/sertificates/logo/iso45001.jpg',
          filePath: '/doc/sertificates/ISO 45001.pdf',
          sgs: true
        },
        {
          standard: 'ISO 27001',
          name: 'iso27001_name',
          alt: 'ISO 27001',
          contentName: 'iso27001_text',
          src: '/img/sertificates/logo/iso27001.jpg',
          filePath: '/doc/sertificates/ISO 27001 Milsped doo.PDF'
        },
        {
          standard: 'TAPA FSR & TSR',
          name: 'tapa_fsr_name',
          alt: 'TAPA FSR',
          contentName: 'tapa_fsr_text',
          src: '/img/sertificates/logo/tapa_fsr.jpg',
          filePath: '/doc/sertificates/tapatsrfsr.pdf'
        },
        {
          standard: 'AEO',
          name: 'aeo_name',
          alt: 'AEO',
          contentName: 'aeo_text',
          src: '/img/sertificates/logo/aeo.jpg',
          filePath: '/doc/sertificates/OPS 2015.pdf'
        }, 
        {
          standard: 'FSSC 22000',
          standard2: 'FSSC 22000 BC Kać',
          name: 'fssc_22000_name',
          alt: 'FSSC 22000',
          contentName: 'fssc_22000_text',
          src: '/img/sertificates/logo/fssc-22000.jpg',
          filePath: '/doc/sertificates/FSSC 22000.pdf',
          filePath2: '/doc/sertificates/FSSC 22000 BC Kac.pdf',

          sgs: true

        }
      ],
      policies: [
        {
          name: 'Milsped_ESG_Report_2023_policy'
        },
        {
          name: 'env_protection_policy'
        },
        {
          name: 'milsped_group_quality_policy'
        },
        {
          name: 'security_and_health_policy'
        },
        {
          name: 'security_statement'
        },
        {
          name: 'security_food'
        }
      ]
    }
  }
}
</script>

<style scoped>
.submenu-icon {
  @apply mb-3;
}
.header {
  background: linear-gradient(to right, rgba(0, 0, 0, 0.40), rgba(0, 0, 0, 0)),
    url('/img/about_header_background.jpg');
  background-position: center;
  background-size: cover;
  position: relative;
}
.header:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  transform: translateY(100%);
  left: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.07), transparent);
  z-index: -1;
}
.about-content {
  transform: translateY(-75px);
  z-index: 999;
}
</style>
